<template>
    <div class="model" style="margin-top: 0.32rem;">
        <router-link to="/user/profit">
            <div class="model_header">
                <div class="flex align-center" style="height: 100%">
                    <div class="flex align-center flex1">
                        <svg class="icon icon-reset" aria-hidden="true" slot="icon">
                            <use xlink:href="#icon-profit"></use>
                        </svg>
                        <span class="model_title">{{ menuTypes.profit }}</span>
                    </div>
                    <div>
                        <div>
                            <svg class="icon arrow" aria-hidden="true" slot="icon">
                                <use xlink:href="#icon-more"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </router-link>
        <div class="flex model_body">
            <div class="flex1 text-align-left">
                <div class="record">
                    {{ profit.total / 100 || 0}}<span class="small_font black_color" style="margin-left: .03rem;">{{menuTypes.currency}}</span>
                </div>
                <div class="model_money line-h-unset">
                    <span class="black_color">{{ menuTypes.totalProfit }}</span>
                </div>
            </div>
            <div class="flex1 model_body-right">
                <div class="model_content">
                    <div class="model_money">
                        <span class="black_color">{{ menuTypes.retail }}</span>
                        <span class="">{{profit.retail / 100 }}元</span>
                    </div>
                    <div class="model_money line-h-unset">
                        <span class="black_color ">{{ menuTypes.team }}</span>
                        <span class="">{{ profit.team / 100 }}元</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Profit',
  props: ['profit', 'menuTypes'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.model {
    height: unset;
}
.model_header {
    padding: 0 .1rem;
    line-height: unset;
}

.align-center {
    align-items: center;
}

.icon-reset {
    margin: 0;
    width: 1em;
    height: 1em;
    font-size: .24rem;
}

.line-h-unset {
    line-height: unset;
}

.arrow {
    color: #757575;
}

.model_body {
    height: .86rem;
    align-items: center;
    padding: 0 .2rem;
}

.record {
    margin: 0;
    font-weight: 500;
}

.black_color {
    margin: 0;
}

.model_body .model_content {
    margin: 0;
}

.model_body-right {
    text-align: left;
    padding-left: .6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userElement/Profit.vue